import { render, staticRenderFns } from "./DeviceCategories.vue?vue&type=template&id=4ca4e465"
import script from "./DeviceCategories.vue?vue&type=script&lang=js"
export * from "./DeviceCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports